import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import DocumentHead from 'legacyComponents/documentHead';
import { MainWrapper } from 'legacyComponents/styled/lib';
import { Section } from 'legacyComponents/layout/section';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { CategoryCard } from 'legacyComponents/cards/types/category';
import { ThreadCard } from 'legacyComponents/cards/types/thread';
import Button from 'components/Button';
import { VisibilityWrapper } from 'components';

import { clientStore } from 'apps/client/app';
import { modalStore } from 'apps/modals/app';
import { ButtonsWrapper, RepoSpinner } from 'apps/repository/styles';

import { ForumAppManager } from 'apps/forum/main/appManager';
import { Intro } from 'apps/forum/views/intro';
import { CategoryForm } from 'apps/forum/categoryForm/index';
import { ActivateForum } from 'apps/forum/views/activate';

@withNamespaces()
@inject('routerStore')
@observer
export class Forum extends React.Component {
  constructor(props) {
    super(props);
    this.appManager = new ForumAppManager(null, this.props);
  }

  redirectToOrg() {
    const slug = this.props.params.get('initiative');
    clientStore.routerStore.navigate('initiative', {
      initiative: slug,
    });
  }

  clickAddCategory = () => {
    modalStore.SetModalComponent(CategoryForm, {
      forumId: this.appManager.forum.id,
    });
  };

  render() {
    const { t } = this.props;
    const { loading, initiative, forum } = this.appManager;
    if (loading) {
      return (
        <MainWrapper marginBottom='90px'>
          <RepoSpinner />
        </MainWrapper>
      );
    }
    if (initiative === null) {
      // may happen if a microSite specifies a forumSpace that doesn't exist yet.
      return null;
    }
    if (forum === null) {
      return (
        <React.Fragment>
          <DocumentHead title={`${initiative.title} Forum`} />
          <MainWrapper marginBottom='90px'>
            <ActivateForum
              initiative={initiative}
              forumManager={this.appManager}
            />
          </MainWrapper>
        </React.Fragment>
      );
    }

    const { description, pinned, categories } = forum;
    const {
      inSpace: { whichTypes },
    } = initiative;
    const threads = this.appManager.threadsConn.arrayApp;

    return (
      <React.Fragment>
        <DocumentHead title={`${initiative.title} Forum`} />
        <MainWrapper marginBottom='90px'>
          <Intro description={description} />
          <Section title={t('Categories')}>
            {whichTypes.includes('ForumCategory') && (
              <VisibilityWrapper visible={false}>
                <ButtonsWrapper>
                  <Button
                    onClick={this.clickAddCategory}
                    size='small'
                    text={t('New Category')}
                    icon='add'
                    outline
                  />
                </ButtonsWrapper>
              </VisibilityWrapper>
            )}
            <CardSection
              title=''
              cardApp={categories}
              CardComponent={CategoryCard}
              noDataCardType='category'
              owner={whichTypes.includes('ForumCategory')}
              initiative
              noMarginTop
              gridColumns={3}
              gridGap='default'
              intercomTarget='organisation-categories'
            />
          </Section>
          {pinned.apps.length ? (
            <CardSection
              title={t('Pinned 📌')}
              subTitle={' '}
              cardApp={pinned}
              CardComponent={ThreadCard}
            />
          ) : (
            <React.Fragment />
          )}
          <Section title={t('All Threads')}>
            <VisibilityWrapper visible={false}>
              <ButtonsWrapper>
                <Button
                  onClick={this.appManager.OpenThreadForm}
                  size='small'
                  text={t('New Thread')}
                  icon='add'
                  outline
                />
              </ButtonsWrapper>
            </VisibilityWrapper>
            <CardSection
              title=''
              subTitle={' '}
              cardApp={threads}
              CardComponent={ThreadCard}
              noDataCardType='forumThreads'
              noMarginTop
              initiative
            />
          </Section>
        </MainWrapper>
      </React.Fragment>
    );
  }
}

Forum.propTypes = {
  routerStore: PropTypes.object,
  routeName: PropTypes.string,
  params: PropTypes.object,
  t: PropTypes.func,
};
